/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Fable_Plan_DescInputs */

const en_model_fable_plan_desc = /** @type {(inputs: Model_Fable_Plan_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A dedicated package for Claude Fable 5 — the strongest model — on top of everything in Pro.`)
};

const id_model_fable_plan_desc = /** @type {(inputs: Model_Fable_Plan_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket khusus Claude Fable 5 — model terkuat — di atas semua fitur Pro.`)
};

/**
* | output |
* | --- |
* | "A dedicated package for Claude Fable 5 — the strongest model — on top of everything in Pro." |
*
* @param {Model_Fable_Plan_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_fable_plan_desc = /** @type {((inputs?: Model_Fable_Plan_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Fable_Plan_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_fable_plan_desc(inputs)
	return en_model_fable_plan_desc(inputs)
});